import * as yup from 'yup';

export const WorkflowSettingsValidation = yup.object({
	compviewi: yup.string().matches(/^[^!"`'#%&,:;<>=@{}~$()*+?[\]^|]+$/, {
		message: 'Please enter a valid Install/Labor',
	}),
});
